import { render, staticRenderFns } from "./NavbarBasic.vue?vue&type=template&id=962ebcc0&scoped=true"
import script from "./NavbarBasic.vue?vue&type=script&lang=js"
export * from "./NavbarBasic.vue?vue&type=script&lang=js"
import style0 from "./NavbarBasic.vue?vue&type=style&index=0&id=962ebcc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962ebcc0",
  null
  
)

export default component.exports